import { LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';
import React from "react";
const data = [
    {name: 'A', uv: 40.1, amt: 10},
    {name: 'B', uv: 40.8, amt: 10},
    {name: 'C', uv: 40.3, amt: 10},
    {name: 'D', uv: 40.3, amt: 10},
];

class TemperatureGraph extends React.Component {
    render() {
        return (
            <LineChart width={160} height={150} data={data}>
                <Line type="monotone" dataKey="uv" stroke="#E50228" strokeWidth="5"/>
                <CartesianGrid stroke="#ccc" />
                <XAxis label="Temperature" dy={50}/>
                <YAxis />
            </LineChart>
        );
    }
}


export default TemperatureGraph;
